import { UniqMap } from 'src/lib/UniqMap';

import { ACTIVE_PROJECT_TYPE, type ProjectType } from './const';

interface ProjectTypeProps {
  label: string;
  title?: string;
}

const PROJECT_TYPE_PROPS = new UniqMap<ProjectType, ProjectTypeProps>();

// "active" project types
PROJECT_TYPE_PROPS.add(ACTIVE_PROJECT_TYPE.document, {
  label: 'Short form',
  title: 'Document',
});
PROJECT_TYPE_PROPS.add(ACTIVE_PROJECT_TYPE.longFormBuilder, {
  label: 'Long form',
  title: 'Project',
});
PROJECT_TYPE_PROPS.add(ACTIVE_PROJECT_TYPE.blogPostBuilder, {
  label: 'Blog post',
  title: 'Blog',
});
PROJECT_TYPE_PROPS.add(ACTIVE_PROJECT_TYPE.continuousOptimization, {
  label: 'Website Automation',
  title: 'Project',
});
PROJECT_TYPE_PROPS.add(ACTIVE_PROJECT_TYPE.wtmHomePage, {
  label: 'Website Automation',
  title: 'Project',
});

const getProjectTypeProp = <T>(
  type: ProjectType,
  propName: keyof ProjectTypeProps,
  defaultValue?: T
): T | undefined => {
  const props = PROJECT_TYPE_PROPS.get(type);
  if (props && props[propName] != null) {
    return props[propName] as T;
  }
  return defaultValue;
};

export const getProjectTypeLabel = (projectType: ProjectType) =>
  getProjectTypeProp<string>(projectType, 'label', projectType);

export const getProjectTypeTitle = (projectType: ProjectType) =>
  getProjectTypeProp<string>(projectType, 'title', 'Document');
